import type { OOCStatus } from 'Interfaces/FDPInterfaces/oocInterfaces';

export type {
  OOCStatus,
  OOCTabType,
  FCColorType,
  ProbabilityLevel,
  OOCReasonType,
  OOCDateFilter,
  OOCForecastCell,
  OOCReferenceData,
  OOCForecastAdjustment,
  OOCSubmission,
  OOCEmailPreview,
  OOCDashboardCounts,
  OOCAuditLogEntry,
  OOCIntegrationSummary,
  OOCNDCSearchResult,
  OOCSupplierNotification,
  OOCValidationResult,
  OOCValidationWarning,
  OOCProvFacilityRow,
  OOCProvNCVarianceRow,
  OOCMarketDataRow,
} from 'Interfaces/FDPInterfaces/oocInterfaces';

export {
  OOC_REASONS,
  OOC_STATUS_OPTIONS,
  OOC_DATE_FILTER_OPTIONS,
} from 'Interfaces/FDPInterfaces/oocInterfaces';

export type { OOCScreenView } from 'stores/fdpStore/oocStore';

export type SummaryCardKey = OOCStatus | 'all' | 'history';

export const formatOOCNumber = (n: number): string => n.toLocaleString('en-US');

export const formatOOCDate = (dateStr: string | null | undefined): string => {
  if (!dateStr) return '';
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateStr)) return dateStr.replace(/\//g, '-');
  if (/^\d{4}-\d{2}-\d{2}/.test(dateStr)) {
    const [year, month, day] = dateStr.slice(0, 10).split('-');
    return `${month}-${day}-${year}`;
  }
  return dateStr;
};
